(function () {
  'use strict';

  // ── Storage keys ──────────────────────────────────────────────────────────
  var KEY_PREFS    = 'gl_prefs';
  var KEY_MEAS     = 'gl_measurements';
  var KEY_APPTS    = 'gl_appointments';
  var KEY_FT_PREFS = 'ft_prefs';
  var KEY_DT_PREFS = 'dt_prefs';
  var KEY_BL_PREFS = 'bl_prefs';
  var KEY_FT_SESS  = 'ft_sessions';
  var KEY_DT_SESS  = 'dt_sessions';
  var KEY_BL_LOGS  = 'bl_logs';

  // ── WHO Growth Standards (approximate monthly values) ────────────────────
  // Format per row: [P3, P15, P50, P85, P97]
  var WHO = {
    weight: {
      girls: [[2.4,2.8,3.2,3.7,4.2],[3.0,3.4,4.0,4.6,5.1],[3.6,4.1,4.7,5.4,6.0],[4.1,4.7,5.4,6.2,6.9],[4.6,5.2,5.9,6.8,7.6],[5.0,5.6,6.4,7.4,8.2],[5.3,6.0,6.8,7.8,8.7],[5.6,6.3,7.2,8.2,9.2],[5.9,6.6,7.5,8.6,9.6],[6.1,6.9,7.7,8.9,9.9],[6.3,7.1,8.0,9.2,10.2],[6.5,7.3,8.2,9.4,10.5],[6.7,7.5,8.5,9.7,10.8],[6.9,7.7,8.7,10.0,11.0],[7.0,7.9,9.0,10.2,11.3],[7.2,8.1,9.2,10.5,11.6],[7.4,8.3,9.4,10.7,11.8],[7.5,8.5,9.6,10.9,12.1],[7.7,8.6,9.8,11.2,12.3],[7.9,8.8,10.0,11.4,12.6],[8.0,9.0,10.2,11.6,12.8],[8.2,9.2,10.4,11.8,13.0],[8.4,9.4,10.6,12.0,13.2],[8.5,9.5,10.8,12.2,13.4],[8.7,9.7,11.0,12.4,13.7]],
      boys:  [[2.5,2.9,3.3,3.8,4.3],[3.1,3.6,4.1,4.7,5.3],[3.8,4.3,4.9,5.5,6.2],[4.4,4.9,5.6,6.4,7.1],[4.9,5.5,6.2,7.0,7.8],[5.3,5.9,6.7,7.6,8.4],[5.7,6.4,7.1,8.0,8.9],[5.9,6.7,7.4,8.4,9.3],[6.2,7.0,7.7,8.8,9.7],[6.4,7.3,8.0,9.1,10.1],[6.6,7.5,8.3,9.4,10.4],[6.8,7.8,8.5,9.7,10.7],[7.0,8.0,8.8,9.9,11.0],[7.2,8.2,9.0,10.2,11.3],[7.4,8.4,9.2,10.5,11.6],[7.6,8.6,9.5,10.7,11.9],[7.8,8.8,9.7,10.9,12.1],[7.9,9.0,9.9,11.2,12.4],[8.1,9.2,10.1,11.4,12.6],[8.3,9.3,10.3,11.6,12.9],[8.4,9.5,10.5,11.9,13.1],[8.6,9.7,10.7,12.1,13.4],[8.7,9.9,10.9,12.3,13.6],[8.9,10.1,11.1,12.5,13.9],[9.1,10.3,11.3,12.7,14.1]],
    },
    length: {
      girls: [[44.8,46.1,47.3,48.6,49.9],[48.1,49.6,51.0,52.5,53.9],[51.0,52.7,54.2,55.8,57.3],[53.5,55.3,57.0,58.7,60.3],[55.8,57.6,59.4,61.2,62.9],[57.8,59.7,61.6,63.4,65.3],[59.6,61.6,63.5,65.4,67.3],[61.2,63.2,65.2,67.1,69.2],[62.7,64.8,66.9,68.8,70.9],[64.0,66.2,68.4,70.4,72.5],[65.3,67.5,69.8,71.8,73.9],[66.5,68.7,71.1,73.2,75.4],[67.7,69.9,72.4,74.5,76.7],[68.8,71.0,73.6,75.7,77.9],[69.9,72.1,74.8,76.9,79.2],[71.0,73.2,76.0,78.1,80.4],[72.0,74.2,77.1,79.3,81.6],[73.0,75.2,78.1,80.3,82.6],[74.0,76.2,79.2,81.4,83.7],[74.9,77.1,80.1,82.4,84.7],[75.8,78.0,81.1,83.3,85.7],[76.7,79.0,82.0,84.3,86.7],[77.5,79.8,83.0,85.2,87.6],[78.4,80.7,83.9,86.2,88.6],[79.3,81.6,84.9,87.1,89.5]],
      boys:  [[44.2,45.4,46.6,47.9,49.2],[47.5,48.8,50.2,51.7,53.1],[50.5,51.9,53.4,55.0,56.5],[53.1,54.6,56.3,57.9,59.5],[55.3,56.9,58.7,60.4,62.1],[57.4,59.0,60.9,62.7,64.5],[59.2,60.9,62.9,64.8,66.7],[60.9,62.6,64.7,66.6,68.5],[62.4,64.2,66.3,68.3,70.2],[63.8,65.7,67.8,69.9,71.8],[65.1,67.0,69.2,71.3,73.3],[66.4,68.3,70.5,72.7,74.7],[67.5,69.5,71.8,73.9,76.0],[68.6,70.6,73.0,75.2,77.3],[69.6,71.7,74.1,76.3,78.4],[70.7,72.8,75.2,77.5,79.7],[71.7,73.8,76.3,78.6,80.8],[72.7,74.8,77.4,79.7,81.9],[73.6,75.8,78.4,80.7,82.9],[74.5,76.7,79.4,81.7,84.0],[75.4,77.6,80.3,82.7,85.0],[76.3,78.6,81.3,83.7,86.0],[77.1,79.5,82.2,84.6,86.9],[78.0,80.4,83.1,85.6,87.9],[78.8,81.2,84.0,86.5,88.9]],
    },
    head: {
      // 0–18 months only (index 0–18)
      girls: [[31.5,32.4,33.2,34.0,34.8],[34.0,34.9,35.8,36.7,37.6],[35.6,36.5,37.4,38.3,39.3],[36.9,37.8,38.8,39.7,40.7],[38.0,38.9,39.9,40.9,41.9],[38.9,39.8,40.8,41.9,42.9],[39.7,40.6,41.7,42.7,43.8],[40.4,41.3,42.4,43.5,44.6],[41.0,41.9,43.1,44.2,45.3],[41.6,42.5,43.7,44.8,46.0],[42.1,43.0,44.2,45.4,46.6],[42.5,43.5,44.7,45.9,47.1],[43.0,43.9,45.1,46.3,47.6],[43.4,44.3,45.5,46.7,48.0],[43.7,44.6,45.8,47.1,48.4],[44.0,44.9,46.2,47.4,48.7],[44.3,45.2,46.5,47.7,49.0],[44.5,45.5,46.8,48.0,49.3],[44.8,45.7,47.0,48.3,49.6]],
      boys:  [[32.1,33.0,33.9,34.9,35.8],[34.6,35.5,36.5,37.4,38.3],[36.2,37.1,38.1,39.0,40.0],[37.4,38.4,39.4,40.4,41.4],[38.4,39.4,40.4,41.4,42.4],[39.3,40.3,41.3,42.4,43.4],[40.0,41.0,42.1,43.2,44.2],[40.7,41.7,42.8,43.9,45.0],[41.3,42.3,43.4,44.5,45.6],[41.8,42.9,44.0,45.1,46.3],[42.3,43.4,44.5,45.7,46.9],[42.8,43.9,45.0,46.2,47.4],[43.2,44.3,45.5,46.7,47.9],[43.6,44.7,45.9,47.1,48.3],[43.9,45.1,46.3,47.5,48.7],[44.2,45.4,46.6,47.8,49.0],[44.5,45.7,46.9,48.1,49.3],[44.8,46.0,47.2,48.4,49.6],[45.0,46.2,47.4,48.7,49.9]],
    },
  };

  var PCTILE_VALS  = [3, 15, 50, 85, 97];
  var CHART_Y = {
    weight: { min: 1.5, max: 15.5 },
    length: { min: 42,  max: 95 },
    head:   { min: 29,  max: 52 },
  };

  // Well-baby visit schedules (days from birth)
  var WELLBABY_SCHEDULES = {
    US: [
      { name: 'Newborn check', dMin: 3, dMax: 7 },
      { name: '1-month visit', dMin: 25, dMax: 42 },
      { name: '2-month visit', dMin: 49, dMax: 70 },
      { name: '4-month visit', dMin: 105, dMax: 126 },
      { name: '6-month visit', dMin: 168, dMax: 196 },
      { name: '9-month visit', dMin: 252, dMax: 280 },
      { name: '12-month visit', dMin: 336, dMax: 364 },
      { name: '15-month visit', dMin: 420, dMax: 448 },
      { name: '18-month visit', dMin: 504, dMax: 532 },
      { name: '24-month visit', dMin: 672, dMax: 735 },
    ],
    UK: [
      { name: 'Newborn check', dMin: 0, dMax: 5 },
      { name: '6-week check', dMin: 35, dMax: 50 },
      { name: '8-week visit', dMin: 50, dMax: 65 },
      { name: '12-week visit', dMin: 77, dMax: 91 },
      { name: '16-week visit', dMin: 105, dMax: 119 },
      { name: '1-year review', dMin: 336, dMax: 392 },
      { name: '2-year check', dMin: 672, dMax: 750 },
    ],
    AU: [
      { name: 'Newborn check', dMin: 1, dMax: 7 },
      { name: '6-week visit', dMin: 35, dMax: 49 },
      { name: '2-month visit', dMin: 56, dMax: 70 },
      { name: '4-month visit', dMin: 112, dMax: 126 },
      { name: '6-month visit', dMin: 168, dMax: 189 },
      { name: '12-month visit', dMin: 336, dMax: 364 },
      { name: '18-month visit', dMin: 504, dMax: 546 },
      { name: '2-year check', dMin: 672, dMax: 750 },
    ],
  };

  var APPT_LABELS = {
    well_baby: 'Well-baby visit', sick: 'Sick visit', specialist: 'Specialist',
    health_visitor: 'Health visitor', dentist: 'Dentist', eye: 'Eye check', other: 'Appointment',
  };

  // AI proxy
  var LOCAL_DEV_RX   = /^(localhost|127\.0\.0\.1|.*\.local)$/i;
  var STAGING_WORKER = 'https://birch-ai-edge.api-staging.birchstore.com/apps/ai';
  function resolveAIProxy() {
    var theme = window.Theme;
    if (theme && theme.routes && theme.routes.aiProxy) return theme.routes.aiProxy;
    return LOCAL_DEV_RX.test(window.location.hostname) ? STAGING_WORKER : '/apps/ai';
  }

  // ── Cloud sync ────────────────────────────────────────────────────────────
  var CLOUD_BASE = '/apps/ai/tracker/growth';
  var _syncTimer = null;
  var _trackerContext = { type: 'own', childId: null, childName: null, ownerId: null, ownerName: null };
  var _allContexts    = [];
  var _activeChildId  = null;

  function cloudApi() {
    if (_trackerContext.type === 'shared' && _trackerContext.ownerId) {
      return '/apps/ai/tracker-caregivers/data/growth?ownerId=' + encodeURIComponent(_trackerContext.ownerId);
    }
    var cid = _trackerContext.childId || _activeChildId;
    return cid ? CLOUD_BASE + '?childId=' + encodeURIComponent(cid) : CLOUD_BASE;
  }

  function _cloudPayload() {
    return {
      measurements: measurements,
      appointments: appointments,
      prefs: prefs,
      updatedAt: Date.now(),
    };
  }

  function syncToCloud() {
    clearTimeout(_syncTimer);
    _syncTimer = setTimeout(function () {
      fetch(cloudApi(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(_cloudPayload()),
      }).catch(function () {});
    }, 400);
  }

  function loadFromCloud(callback) {
    fetch(cloudApi(), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) {
        if (!json || !json.data || typeof json.data !== 'object') { if (callback) callback(); return; }
        var d = json.data;
        if (Array.isArray(d.measurements)) {
          measurements = d.measurements;
          try { localStorage.setItem(KEY_MEAS, JSON.stringify(measurements)); } catch {}
        }
        if (Array.isArray(d.appointments)) {
          appointments = d.appointments;
          try { localStorage.setItem(KEY_APPTS, JSON.stringify(appointments)); } catch {}
        }
        if (d.prefs && typeof d.prefs === 'object') {
          prefs = Object.assign({}, DEFAULT_PREFS, d.prefs);
          if (prefs.babyName)      babyName      = prefs.babyName;
          if (prefs.babyBirthdate) babyBirthdate = new Date(prefs.babyBirthdate);
          try { localStorage.setItem(KEY_PREFS, JSON.stringify(prefs)); } catch {}
        }
        if (callback) callback();
      })
      .catch(function () { if (callback) callback(); });
  }

  function switchActiveChild() {
    if (_allContexts.length < 2) return;
    var picker = window.BirchChildren && window.BirchChildren.pickContext
      ? window.BirchChildren.pickContext(_allContexts, { title: 'Whose growth tracker?' })
      : Promise.resolve(null);
    picker.then(function (ctx) {
      if (!ctx) return;
      _trackerContext = ctx;
      _activeChildId  = ctx.childId || null;
      babyName        = ctx.childName || 'Baby';
      babyBirthdate   = ctx.dob ? new Date(ctx.dob) : null;
      prefs.babyName       = babyName;
      prefs.babyBirthdate  = ctx.dob || null;
      prefs.onboardingDone = true;
      saveData();
      measurements = []; appointments = [];
      loadFromCloud(function () {
        renderTopbar();
        renderHome();
        renderChart(currentChart);
        showToast('Switched to ' + (ctx.type === 'shared' ? ctx.childName + "'s tracker (" + ctx.ownerName + "'s)" : ctx.childName + "'s tracker"));
      });
    });
  }

  // ── State ─────────────────────────────────────────────────────────────────
  var prefs        = {};
  var measurements = [];
  var appointments = [];
  var babyName     = 'Baby';
  var babyBirthdate = null;
  var currentChart  = 'weight';
  var currentApptId = null;
  var measureBy     = 'clinic';
  var velocityDismissed = false;

  var DEFAULT_PREFS = {
    sex: 'unspecified', country: 'US', unitWeight: 'kg', unitLength: 'cm',
    gestationalAge: 40, birthWeight: null, birthLength: null, birthHeadCirc: null,
    onboardingDone: false,
  };

  // ── Data loading / saving ─────────────────────────────────────────────────
  function loadData() {
    try { prefs        = Object.assign({}, DEFAULT_PREFS, JSON.parse(localStorage.getItem(KEY_PREFS) || '{}')); } catch { prefs = Object.assign({}, DEFAULT_PREFS); }
    try { measurements = JSON.parse(localStorage.getItem(KEY_MEAS)  || '[]'); } catch { measurements = []; }
    try { appointments = JSON.parse(localStorage.getItem(KEY_APPTS) || '[]'); } catch { appointments = []; }

    // Read baby profile from sibling trackers if not set
    var siblingPrefs = null;
    try { siblingPrefs = JSON.parse(localStorage.getItem(KEY_FT_PREFS) || '{}'); } catch {}
    if (!siblingPrefs || !siblingPrefs.babyName) {
      try { siblingPrefs = JSON.parse(localStorage.getItem(KEY_DT_PREFS) || '{}'); } catch {}
    }
    if (!siblingPrefs || !siblingPrefs.babyName) {
      try { siblingPrefs = JSON.parse(localStorage.getItem(KEY_BL_PREFS) || '{}'); } catch {}
    }
    if (siblingPrefs) {
      if (siblingPrefs.babyName) babyName = siblingPrefs.babyName;
      if (siblingPrefs.babyBirthdate || siblingPrefs.birthdate) {
        babyBirthdate = new Date(siblingPrefs.babyBirthdate || siblingPrefs.birthdate);
      }
      if (siblingPrefs.gestationalAge && !prefs.gestationalAge) {
        prefs.gestationalAge = siblingPrefs.gestationalAge;
      }
    }
  }

  function saveData() {
    try { localStorage.setItem(KEY_PREFS,  JSON.stringify(prefs)); } catch {}
    try { localStorage.setItem(KEY_MEAS,   JSON.stringify(measurements)); } catch {}
    try { localStorage.setItem(KEY_APPTS,  JSON.stringify(appointments)); } catch {}
    syncToCloud();
  }

  // ── Age helpers ───────────────────────────────────────────────────────────
  function getAgeWeeks(asOf) {
    if (!babyBirthdate) return 0;
    var ref = asOf ? new Date(asOf) : new Date();
    return Math.floor((ref.getTime() - babyBirthdate.getTime()) / (7 * 86400000));
  }

  function getAgeMonths(asOf) {
    if (!babyBirthdate) return 0;
    var ref = asOf ? new Date(asOf) : new Date();
    return (ref.getTime() - babyBirthdate.getTime()) / (30.44 * 86400000);
  }

  function getAdjustedAgeMonths(asOf) {
    var chrono = getAgeMonths(asOf);
    var adjust = (40 - (prefs.gestationalAge || 40)) / 4.33;
    return Math.max(0, chrono - adjust);
  }

  function formatAge(date) {
    var months = Math.floor(getAgeMonths(date));
    var weeks  = getAgeWeeks(date);
    if (months >= 1) return months + ' month' + (months !== 1 ? 's' : '');
    return weeks + ' week' + (weeks !== 1 ? 's' : '');
  }

  function formatDate(iso) {
    return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }

  function todayIso() { return new Date().toISOString().slice(0, 10); }
  function escHtml(s) { return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

  // ── WHO percentile helpers ────────────────────────────────────────────────
  function getWHORow(type, sex, monthFloat) {
    var sexKey = (sex === 'male') ? 'boys' : 'girls';
    var data   = WHO[type][sexKey];
    if (!data) return null;
    var maxIdx = data.length - 1;
    var m      = Math.max(0, Math.min(monthFloat, maxIdx));
    var mLow   = Math.floor(m);
    var mHigh  = Math.min(Math.ceil(m), maxIdx);
    if (mLow === mHigh) return data[mLow];
    var t = m - mLow;
    return data[mLow].map(function (v, i) { return v + t * (data[mHigh][i] - v); });
  }

  function estimatePercentile(type, sex, monthFloat, value) {
    var row = getWHORow(type, sex, monthFloat);
    if (!row) return null;
    // Bands: <p3=1.5, p3-p15=9, p15-p50=35, p50-p85=67.5, p85-p97=91, >p97=98.5
    var bands = [[0, row[0], 3], [row[0], row[1], 3, 15], [row[1], row[2], 15, 50], [row[2], row[3], 50, 85], [row[3], row[4], 85, 97], [row[4], Infinity, 97, 100]];
    for (var i = 0; i < bands.length; i++) {
      var b = bands[i];
      if (value <= b[1]) {
        if (i === 0) return Math.round(Math.max(1, 3 * (value - 0) / b[1]));
        if (i === bands.length - 1) return 99;
        var pLow = b[2], pHigh = b[3];
        var t = (value - b[0]) / (b[1] - b[0]);
        return Math.round(pLow + t * (pHigh - pLow));
      }
    }
    return 99;
  }

  function pctileLabel(p) {
    if (p === null) return '';
    var ordinal = p === 1 ? '1st' : p === 2 ? '2nd' : p === 3 ? '3rd' : p + 'th';
    return ordinal + ' %ile';
  }

  // ── Unit display helpers ──────────────────────────────────────────────────
  function displayWeight(kg) {
    if (kg == null) return '—';
    if (prefs.unitWeight === 'lbs') {
      var totalOz = Math.round(kg * 35.274);
      var lb = Math.floor(totalOz / 16), oz = totalOz % 16;
      return lb + ' lb ' + oz + ' oz';
    }
    return kg.toFixed(2) + ' kg';
  }

  function displayLength(cm) {
    if (cm == null) return '—';
    if (prefs.unitLength === 'in') return (cm / 2.54).toFixed(1) + '"';
    return cm.toFixed(1) + ' cm';
  }

  function inputWeightToKg(val) {
    var n = parseFloat(val);
    if (isNaN(n)) return null;
    return prefs.unitWeight === 'lbs' ? n * 0.453592 : n;
  }

  function inputLengthToCm(val) {
    var n = parseFloat(val);
    if (isNaN(n)) return null;
    return prefs.unitLength === 'in' ? n * 2.54 : n;
  }

  // ── Growth chart (SVG) ───────────────────────────────────────────────────
  var SVG_W = 340, SVG_H = 220;
  var CHART_L = 42, CHART_R = 320, CHART_T = 10, CHART_B = 195;
  var CHART_W = CHART_R - CHART_L;
  var CHART_H = CHART_B - CHART_T;

  function cx(monthFloat, maxMonths) { return CHART_L + (monthFloat / maxMonths) * CHART_W; }
  function cy(value, min, max) { return CHART_B - ((value - min) / (max - min)) * CHART_H; }

  function renderChart(type) {
    var container = document.getElementById('gl-chart-container');
    if (!container) return;
    var maxMonths = type === 'head' ? 18 : 24;
    var sexKey = prefs.sex === 'male' ? 'boys' : 'girls';
    var data   = WHO[type][sexKey];
    var yRange = CHART_Y[type];
    if (!data) { container.innerHTML = ''; return; }

    var svgNS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('viewBox', '0 0 ' + SVG_W + ' ' + SVG_H);
    svg.setAttribute('width', '100%');
    svg.setAttribute('height', SVG_H);

    function pt(m, v) { return cx(m, maxMonths).toFixed(1) + ',' + cy(v, yRange.min, yRange.max).toFixed(1); }

    // Band fills: outer (3-97), middle (15-85)
    var outerPts = '', innerPts = '';
    for (var m = 0; m <= maxMonths; m++) {
      var row = WHO[type][sexKey][Math.min(m, data.length - 1)];
      outerPts += (m === 0 ? 'M' : 'L') + pt(m, row[0]);
    }
    for (var m2 = maxMonths; m2 >= 0; m2--) {
      outerPts += 'L' + pt(m2, WHO[type][sexKey][Math.min(m2, data.length-1)][4]);
    }
    outerPts += 'Z';

    for (var m3 = 0; m3 <= maxMonths; m3++) {
      var row3 = WHO[type][sexKey][Math.min(m3, data.length - 1)];
      innerPts += (m3 === 0 ? 'M' : 'L') + pt(m3, row3[1]);
    }
    for (var m4 = maxMonths; m4 >= 0; m4--) {
      innerPts += 'L' + pt(m4, WHO[type][sexKey][Math.min(m4, data.length-1)][3]);
    }
    innerPts += 'Z';

    function mkPath(d, fill, opacity, stroke) {
      var p = document.createElementNS(svgNS, 'path');
      p.setAttribute('d', d);
      if (fill)    p.setAttribute('fill', fill);
      if (opacity) p.setAttribute('fill-opacity', opacity);
      if (stroke)  p.setAttribute('stroke', stroke);
      else         p.setAttribute('stroke', 'none');
      return p;
    }

    svg.appendChild(mkPath(outerPts, '#4CAF8A', '0.15'));
    svg.appendChild(mkPath(innerPts, '#4CAF8A', '0.22'));

    // Percentile lines (P50 solid, others dashed)
    [0, 1, 2, 3, 4].forEach(function (pIdx) {
      var d = '';
      for (var m5 = 0; m5 <= maxMonths; m5++) {
        var row5 = WHO[type][sexKey][Math.min(m5, data.length-1)];
        d += (m5 === 0 ? 'M' : 'L') + pt(m5, row5[pIdx]);
      }
      var line = document.createElementNS(svgNS, 'path');
      line.setAttribute('d', d);
      line.setAttribute('fill', 'none');
      line.setAttribute('stroke', pIdx === 2 ? '#2A6B50' : '#4CAF8A');
      line.setAttribute('stroke-width', pIdx === 2 ? '1.5' : '0.8');
      if (pIdx !== 2) line.setAttribute('stroke-dasharray', '3 3');
      line.setAttribute('stroke-opacity', pIdx === 2 ? '0.9' : '0.5');
      svg.appendChild(line);
    });

    // Gridlines
    var monthLabels = type === 'head' ? [0,3,6,9,12,15,18] : [0,3,6,9,12,15,18,21,24];
    monthLabels.forEach(function (m6) {
      var x6 = cx(m6, maxMonths);
      var gl = document.createElementNS(svgNS, 'line');
      gl.setAttribute('x1', x6); gl.setAttribute('y1', CHART_T);
      gl.setAttribute('x2', x6); gl.setAttribute('y2', CHART_B);
      gl.setAttribute('stroke', '#E2EBE5'); gl.setAttribute('stroke-width', '0.5');
      svg.appendChild(gl);
      var lt = document.createElementNS(svgNS, 'text');
      lt.setAttribute('x', x6); lt.setAttribute('y', SVG_H - 2);
      lt.setAttribute('text-anchor', 'middle'); lt.setAttribute('font-size', '9');
      lt.setAttribute('fill', '#6B7B72'); lt.textContent = m6 + 'm';
      svg.appendChild(lt);
    });

    // Y-axis labels
    var ySteps = type === 'weight' ? [3,5,7,9,11,13,15] : type === 'length' ? [45,55,65,75,85,95] : [30,35,40,45,50];
    ySteps.forEach(function (yv) {
      if (yv < yRange.min || yv > yRange.max) return;
      var yy = cy(yv, yRange.min, yRange.max);
      var yt = document.createElementNS(svgNS, 'text');
      yt.setAttribute('x', CHART_L - 3); yt.setAttribute('y', yy + 3);
      yt.setAttribute('text-anchor', 'end'); yt.setAttribute('font-size', '8.5');
      yt.setAttribute('fill', '#6B7B72'); yt.textContent = yv;
      svg.appendChild(yt);
    });

    // Baby's measurements
    var measForType = measurements.filter(function (m) {
      var val = type === 'weight' ? m.weightKg : type === 'length' ? m.lengthCm : m.headCircCm;
      if (val == null) return false;
      var monthsAtMeas = getAdjustedAgeMonths(m.measuredAt);
      return monthsAtMeas >= 0 && monthsAtMeas <= maxMonths;
    }).sort(function (a, b) { return new Date(a.measuredAt) - new Date(b.measuredAt); });

    if (measForType.length > 1) {
      var linePts = '';
      measForType.forEach(function (m, i) {
        var val  = type === 'weight' ? m.weightKg : type === 'length' ? m.lengthCm : m.headCircCm;
        var mAge = getAdjustedAgeMonths(m.measuredAt);
        var x7   = cx(mAge, maxMonths), y7 = cy(val, yRange.min, yRange.max);
        linePts += (i === 0 ? 'M' : 'L') + x7.toFixed(1) + ',' + y7.toFixed(1);
      });
      var bline = document.createElementNS(svgNS, 'path');
      bline.setAttribute('d', linePts); bline.setAttribute('fill', 'none');
      bline.setAttribute('stroke', '#2A6B50'); bline.setAttribute('stroke-width', '2');
      bline.setAttribute('stroke-linecap', 'round'); bline.setAttribute('stroke-linejoin', 'round');
      svg.appendChild(bline);
    }

    measForType.forEach(function (m) {
      var val  = type === 'weight' ? m.weightKg : type === 'length' ? m.lengthCm : m.headCircCm;
      var mAge = getAdjustedAgeMonths(m.measuredAt);
      var x8   = cx(mAge, maxMonths), y8 = cy(val, yRange.min, yRange.max);
      var dot  = document.createElementNS(svgNS, 'circle');
      dot.setAttribute('cx', x8); dot.setAttribute('cy', y8);
      dot.setAttribute('r', '5'); dot.setAttribute('fill', '#2A6B50');
      dot.setAttribute('stroke', 'white'); dot.setAttribute('stroke-width', '1.5');
      dot.style.cursor = 'pointer';
      dot.addEventListener('click', function () { showChartDotTooltip(m, type, val, mAge); });
      svg.appendChild(dot);
    });

    // Percentile labels at right edge
    [0,1,2,3,4].forEach(function (pIdx) {
      var row = data[data.length - 1];
      var labelY = cy(row[pIdx], yRange.min, yRange.max);
      var lt2 = document.createElementNS(svgNS, 'text');
      lt2.setAttribute('x', CHART_R + 3); lt2.setAttribute('y', labelY + 3);
      lt2.setAttribute('font-size', '8'); lt2.setAttribute('fill', '#4CAF8A');
      lt2.textContent = 'P' + PCTILE_VALS[pIdx];
      svg.appendChild(lt2);
    });

    container.innerHTML = '';
    container.appendChild(svg);

    // Update current percentile label
    var latest = measForType[measForType.length - 1];
    var pctEl  = document.getElementById('gl-pct-label');
    if (pctEl) {
      if (latest) {
        var val2 = type === 'weight' ? latest.weightKg : type === 'length' ? latest.lengthCm : latest.headCircCm;
        var mAge2 = getAdjustedAgeMonths(latest.measuredAt);
        var p = estimatePercentile(type, prefs.sex, mAge2, val2);
        var typeLabel = type === 'weight' ? 'weight' : type === 'length' ? 'length' : 'head circumference';
        pctEl.textContent = babyName + ' is at the ' + pctileLabel(p) + ' for ' + typeLabel;
        pctEl.style.display = '';
      } else {
        pctEl.style.display = 'none';
      }
    }
  }

  function showChartDotTooltip(m, type, val, mAge) {
    var p = estimatePercentile(type, prefs.sex, mAge, val);
    var dispVal = type === 'weight' ? displayWeight(val) : displayLength(val);
    showToast(dispVal + ' · ' + pctileLabel(p) + ' · ' + formatDate(m.measuredAt));
  }

  // ── Velocity detection ────────────────────────────────────────────────────
  function detectVelocity() {
    var sorted = measurements.filter(function (m) { return m.weightKg; })
      .sort(function (a, b) { return new Date(a.measuredAt) - new Date(b.measuredAt); });
    if (sorted.length < 2) return null;
    var prev = sorted[sorted.length - 2], curr = sorted[sorted.length - 1];
    var prevAge = getAdjustedAgeMonths(prev.measuredAt);
    var currAge = getAdjustedAgeMonths(curr.measuredAt);
    var prevP   = estimatePercentile('weight', prefs.sex, prevAge, prev.weightKg);
    var currP   = estimatePercentile('weight', prefs.sex, currAge, curr.weightKg);
    var diffP   = currP - prevP;
    var diffW   = (new Date(curr.measuredAt) - new Date(prev.measuredAt)) / (7 * 86400000);
    if (diffP <= -10 && diffW <= 12) {
      return {
        type: 'drop',
        title: 'Weight gain has slowed',
        text: babyName + '\'s weight gain slowed over the last ' + Math.round(diffW) + ' weeks — from around the ' + prevP + 'th to the ' + currP + 'th percentile. This can be completely normal, especially during solids introduction. Worth mentioning at the next appointment.',
      };
    }
    if (diffP >= 15) {
      return {
        type: 'rise',
        title: 'Growth spurt pattern',
        text: babyName + '\'s weight gain has been strong this period — tracking higher than the previous trend. This often happens during a growth spurt.',
      };
    }
    return null;
  }

  // ── Newborn weight loss ───────────────────────────────────────────────────
  function getNewbornWeightStatus() {
    if (!babyBirthdate || !prefs.birthWeight) return null;
    var daysOld = (Date.now() - babyBirthdate.getTime()) / 86400000;
    if (daysOld > 14) return null;
    var latestW = null;
    measurements.slice().sort(function (a, b) { return new Date(b.measuredAt) - new Date(a.measuredAt); })
      .forEach(function (m) { if (m.weightKg && latestW === null) latestW = m.weightKg; });
    if (!latestW) return null;
    var pctChange = ((latestW - prefs.birthWeight) / prefs.birthWeight) * 100;
    return { pctChange: pctChange, birthWeight: prefs.birthWeight, current: latestW };
  }

  // ── Cross-tracker context ─────────────────────────────────────────────────
  function getCrossTrackerContext(daysSince) {
    var ctx   = {};
    var since = Date.now() - (daysSince || 14) * 86400000;
    try {
      var ftSess = JSON.parse(localStorage.getItem(KEY_FT_SESS) || '[]');
      var recent = ftSess.filter(function (s) { return new Date(s.start || s.startTime || s.date || 0).getTime() > since; });
      ctx.feedCount = recent.length;
      ctx.feedNote  = recent.length > 0 ? recent.length + ' feeds in last ' + daysSince + ' days' : null;
    } catch {}
    try {
      var dtSess  = JSON.parse(localStorage.getItem(KEY_DT_SESS) || '[]');
      var recentDt = dtSess.filter(function (s) { return new Date(s.start || s.startIso || s.date || 0).getTime() > since; });
      var totalMin = recentDt.reduce(function (acc, s) { return acc + ((s.durationMin || s.duration) || 0); }, 0);
      ctx.avgNightSleep = totalMin > 0 ? Math.round(totalMin / Math.max(recentDt.length, 1)) + ' min avg/session' : null;
    } catch {}
    try {
      var blLogs   = JSON.parse(localStorage.getItem(KEY_BL_LOGS) || '[]');
      var recentBl = blLogs.filter(function (l) { return new Date(l.timestamp || l.date || 0).getTime() > since; });
      var reflux   = recentBl.filter(function (l) { return l.type === 'reflux'; });
      ctx.refluxCount  = reflux.length;
      ctx.refluxFlagged = reflux.filter(function (l) { return l.severity === 'large' || l.severity === 'projectile'; }).length;
    } catch {}
    return ctx;
  }

  function buildWellBabySchedule() {
    if (!babyBirthdate) return [];
    var schedule = (WELLBABY_SCHEDULES[prefs.country || 'US'] || WELLBABY_SCHEDULES.US);
    var now = Date.now();
    return schedule.map(function (v) {
      var targetDate = new Date(babyBirthdate.getTime() + Math.round((v.dMin + v.dMax) / 2) * 86400000);
      var daysUntil  = Math.round((targetDate.getTime() - now) / 86400000);
      var alreadyLogged = appointments.some(function (a) { return a.type === 'well_baby' && a.scheduleKey === v.name; });
      return { name: v.name, targetDate: targetDate.toISOString().slice(0,10), daysUntil: daysUntil, alreadyLogged: alreadyLogged };
    }).filter(function (v) { return v.daysUntil > -60; });
  }

  // ── ICS generation ────────────────────────────────────────────────────────
  function formatIcsDate(d) {
    return d.toISOString().replace(/[-:]/g,'').replace(/\.\d{3}Z/, 'Z');
  }

  function generateIcs(appt) {
    var start  = new Date(appt.scheduledAt);
    var end    = new Date(start.getTime() + 60 * 60000);
    var lines  = [
      'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Birch Baby Suite//GrowthLog//EN', 'BEGIN:VEVENT',
      'UID:' + appt.id + '@birch-growthlog',
      'DTSTART:' + formatIcsDate(start),
      'DTEND:' + formatIcsDate(end),
      'SUMMARY:' + babyName + "'s " + (APPT_LABELS[appt.type] || 'appointment'),
      'DESCRIPTION:' + (appt.vaccinesDue ? 'Vaccines due: ' + appt.vaccinesDue.join(', ') + '\\n\\n' : '') + 'Logged in GrowthLog · Birch Baby Suite',
      'LOCATION:' + (appt.location || ''),
      'BEGIN:VALARM', 'TRIGGER:-P7D', 'ACTION:DISPLAY', 'DESCRIPTION:Appointment in one week', 'END:VALARM',
      'BEGIN:VALARM', 'TRIGGER:-P1D', 'ACTION:DISPLAY', 'DESCRIPTION:Appointment is tomorrow', 'END:VALARM',
      'END:VEVENT', 'END:VCALENDAR',
    ];
    return lines.join('\r\n');
  }

  function downloadIcs(appt) {
    var ics  = generateIcs(appt);
    var blob = new Blob([ics], { type: 'text/calendar' });
    var url  = URL.createObjectURL(blob);
    var a    = document.createElement('a');
    a.href   = url;
    a.download = (babyName + '-' + (APPT_LABELS[appt.type] || 'appt')).replace(/\s+/g, '-') + '.ics';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    showToast('Calendar file downloaded');
  }

  // ── AI pre-appointment questions ──────────────────────────────────────────
  function fetchPrepQuestions(appt) {
    var ctx  = getCrossTrackerContext(30);
    var vel  = detectVelocity();
    var latest = measurements.slice().sort(function (a,b) { return new Date(b.measuredAt)-new Date(a.measuredAt); })[0];
    var payload = {
      babyName: babyName,
      ageDisplay: babyBirthdate ? formatAge(appt.scheduledAt) : '',
      appointmentType: APPT_LABELS[appt.type] || appt.type,
      appointmentDate: formatDate(appt.scheduledAt),
      country: prefs.country || 'US',
      vaccinesDue: appt.vaccinesDue || [],
      weight:          latest && latest.weightKg ? displayWeight(latest.weightKg) : null,
      weightPercentile: latest && latest.weightKg ? estimatePercentile('weight', prefs.sex, getAdjustedAgeMonths(latest.measuredAt), latest.weightKg) : null,
      velocityNote:    vel ? vel.title : null,
      feedNote:        ctx.feedNote || null,
      sleepNote:       ctx.avgNightSleep || null,
      refluxCount:     ctx.refluxCount || null,
      refluxFlagged:   ctx.refluxFlagged || null,
    };
    return fetch(resolveAIProxy() + '/growth/prep-questions', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { return d && d.questions ? d.questions : null; })
      .catch(function () { return null; });
  }

  // ── Rendering: topbar ─────────────────────────────────────────────────────
  function renderTopbar() {
    var titleEl = document.getElementById('gl-topbar-title');
    var ageEl   = document.getElementById('gl-topbar-age');
    if (titleEl) titleEl.textContent = babyName + "'s GrowthLog";
    if (ageEl && babyBirthdate) {
      var months = Math.floor(getAgeMonths());
      ageEl.textContent = months + ' month' + (months !== 1 ? 's' : '') + ' old';
    }
  }

  // ── Rendering: home ───────────────────────────────────────────────────────
  function renderHome() {
    var latest = measurements.slice().sort(function (a, b) { return new Date(b.measuredAt) - new Date(a.measuredAt); })[0];
    var ageMonths = getAdjustedAgeMonths();

    var statsCard  = document.getElementById('gl-stats-card');
    var statsEmpty = document.getElementById('gl-stats-empty');
    var chartsBtn  = document.getElementById('gl-stats-charts-btn');
    var statsDate  = document.getElementById('gl-stats-date');
    var statsTitle = document.getElementById('gl-stats-title');
    if (statsTitle) statsTitle.textContent = babyName + "'s measurements";

    if (!latest) {
      if (statsEmpty) statsEmpty.style.display = '';
      if (chartsBtn)  chartsBtn.style.display = 'none';
    } else {
      if (statsEmpty) statsEmpty.style.display = 'none';
      if (chartsBtn)  chartsBtn.style.display = '';
      if (statsDate)  statsDate.textContent = 'Last measured ' + formatDate(latest.measuredAt);
      renderStatRow('gl-stat-weight', 'Weight', displayWeight(latest.weightKg), latest.weightKg ? pctileLabel(estimatePercentile('weight', prefs.sex, ageMonths, latest.weightKg)) : null, latest.weightKg != null);
      renderStatRow('gl-stat-length', 'Length / Height', displayLength(latest.lengthCm), latest.lengthCm ? pctileLabel(estimatePercentile('length', prefs.sex, ageMonths, latest.lengthCm)) : null, latest.lengthCm != null);
      renderStatRow('gl-stat-head', 'Head', displayLength(latest.headCircCm), latest.headCircCm ? pctileLabel(estimatePercentile('head', prefs.sex, ageMonths, latest.headCircCm)) : null, latest.headCircCm != null && ageMonths < 18);
    }

    // Newborn weight card
    var nwCard = document.getElementById('gl-newborn-card');
    var nwStatus = getNewbornWeightStatus();
    if (nwStatus && nwCard) {
      nwCard.style.display = '';
      var pctEl   = document.getElementById('gl-newborn-pct');
      var noteEl  = document.getElementById('gl-newborn-note');
      var pct     = nwStatus.pctChange;
      if (pctEl) pctEl.textContent = (pct > 0 ? '+' : '') + pct.toFixed(1) + '% from birth weight';
      if (pctEl) pctEl.style.color = pct < -10 ? '#C4760A' : pct < 0 ? '#2A6B50' : '#2A6B50';
      if (noteEl) noteEl.textContent = pct < -10
        ? 'Weight loss over 10% is worth mentioning at the next visit — no need to worry before then.'
        : pct < 0
        ? 'Weight loss up to 10% in the first days is normal. Baby is working back to birth weight.'
        : 'Back at or above birth weight — great sign!';
    } else if (nwCard) {
      nwCard.style.display = 'none';
    }

    // Velocity card
    var vel = velocityDismissed ? null : detectVelocity();
    var velCard = document.getElementById('gl-velocity-card');
    if (vel && velCard) {
      velCard.style.display = '';
      var velTitle = document.getElementById('gl-velocity-title');
      var velText  = document.getElementById('gl-velocity-text');
      var velIcon  = document.getElementById('gl-velocity-icon');
      if (velTitle) velTitle.textContent = vel.title;
      if (velText)  velText.textContent  = vel.text;
      if (velIcon)  velIcon.textContent  = vel.type === 'drop' ? '📉' : '📈';
    } else if (velCard) {
      velCard.style.display = 'none';
    }

    // Next appointment
    var upcoming = appointments.filter(function (a) { return a.status === 'upcoming' && new Date(a.scheduledAt) > new Date(); })
      .sort(function (a, b) { return new Date(a.scheduledAt) - new Date(b.scheduledAt); });
    var next = upcoming[0] || null;
    var nextCard    = document.getElementById('gl-next-appt-card');
    var schedCard   = document.getElementById('gl-schedule-card');
    var apptBanner  = document.getElementById('gl-appt-banner');
    var bannerText  = document.getElementById('gl-appt-banner-text');

    if (next) {
      if (nextCard)  nextCard.style.display = '';
      if (schedCard) schedCard.style.display = 'none';
      var daysUntil = Math.round((new Date(next.scheduledAt) - new Date()) / 86400000);
      var nameEl  = document.getElementById('gl-next-appt-name');
      var metaEl  = document.getElementById('gl-next-appt-meta');
      var vacSec  = document.getElementById('gl-next-appt-vaccines');
      var vacList = document.getElementById('gl-next-appt-vaccines-list');
      if (nameEl) nameEl.textContent = APPT_LABELS[next.type] || next.type;
      if (metaEl) metaEl.textContent = formatDate(next.scheduledAt) + ' · in ' + daysUntil + ' day' + (daysUntil !== 1 ? 's' : '');
      if (next.vaccinesDue && next.vaccinesDue.length && vacSec && vacList) {
        vacSec.style.display = '';
        vacList.textContent  = next.vaccinesDue.join(', ');
      } else if (vacSec) {
        vacSec.style.display = 'none';
      }
      if (apptBanner && daysUntil <= 7) {
        apptBanner.style.display = 'flex';
        if (bannerText) bannerText.textContent = (APPT_LABELS[next.type] || 'Visit') + ' in ' + daysUntil + ' day' + (daysUntil !== 1 ? 's' : '') + '.';
      } else if (apptBanner) {
        apptBanner.style.display = 'none';
      }
    } else {
      if (nextCard)  nextCard.style.display = 'none';
      if (schedCard) schedCard.style.display = '';
      if (apptBanner) apptBanner.style.display = 'none';
    }

  }

  function renderStatRow(id, label, value, pct, show) {
    var row    = document.getElementById(id);
    var valEl  = document.getElementById(id + '-val');
    var pctEl  = document.getElementById(id + '-pct');
    if (!row) return;
    row.style.display = show ? '' : 'none';
    if (valEl) valEl.textContent = value;
    if (pctEl) pctEl.textContent = pct || '';
  }

  // ── Rendering: measurement list ───────────────────────────────────────────
  function renderMeasurementList() {
    var list = document.getElementById('gl-meas-list');
    if (!list) return;
    var sorted = measurements.slice().sort(function (a, b) { return new Date(b.measuredAt) - new Date(a.measuredAt); });
    if (sorted.length === 0) {
      list.innerHTML = '<div class="gl-meas-empty">No measurements yet.</div>';
      return;
    }
    list.innerHTML = '';
    sorted.forEach(function (m) {
      var ageM = getAdjustedAgeMonths(m.measuredAt);
      var row = document.createElement('div');
      row.className = 'gl-meas-row';
      var wPct = m.weightKg ? estimatePercentile('weight', prefs.sex, ageM, m.weightKg) : null;
      row.innerHTML =
        '<div class="gl-meas-row__date">' + formatDate(m.measuredAt) + ' · ' + formatAge(m.measuredAt) + '</div>' +
        '<div class="gl-meas-row__vals">' +
          (m.weightKg  ? '<span>' + displayWeight(m.weightKg) + (wPct ? ' <span class="gl-meas-pct">(' + pctileLabel(wPct) + ')</span>' : '') + '</span>' : '') +
          (m.lengthCm  ? '<span>' + displayLength(m.lengthCm) + '</span>' : '') +
          (m.headCircCm ? '<span>HC ' + displayLength(m.headCircCm) + '</span>' : '') +
        '</div>' +
        '<div class="gl-meas-row__by">' + (m.measuredBy === 'clinic' ? 'Clinic' : m.measuredBy === 'home' ? 'Home' : 'Pharmacy') + '</div>';
      list.appendChild(row);
    });

    // Velocity note on growth screen
    var vel = velocityDismissed ? null : detectVelocity();
    var velInline = document.getElementById('gl-velocity-inline');
    var velInlineText = document.getElementById('gl-velocity-inline-text');
    if (vel && velInline && velInlineText) {
      velInline.style.display = '';
      velInlineText.textContent = vel.text;
    } else if (velInline) {
      velInline.style.display = 'none';
    }
  }

  // ── Rendering: appointments ───────────────────────────────────────────────
  function renderAppointments() {
    var upcomingList = document.getElementById('gl-appt-upcoming-list');
    var upcomingEmpty = document.getElementById('gl-appt-upcoming-empty');
    var pastSection  = document.getElementById('gl-appt-past-section');
    var pastList     = document.getElementById('gl-appt-past-list');
    var pastCount    = document.getElementById('gl-appt-past-count');
    var now          = new Date();

    var upcoming = appointments.filter(function (a) { return a.status === 'upcoming' && new Date(a.scheduledAt) > now; })
      .sort(function (a, b) { return new Date(a.scheduledAt) - new Date(b.scheduledAt); });
    var past = appointments.filter(function (a) { return a.status === 'completed' || new Date(a.scheduledAt) <= now; })
      .sort(function (a, b) { return new Date(b.scheduledAt) - new Date(a.scheduledAt); });

    if (upcomingList) {
      upcomingList.innerHTML = '';
      if (upcoming.length === 0) {
        if (upcomingEmpty) upcomingEmpty.style.display = '';
      } else {
        if (upcomingEmpty) upcomingEmpty.style.display = 'none';
        upcoming.forEach(function (a) { upcomingList.appendChild(buildApptCard(a, false)); });
      }
    }

    if (pastSection) pastSection.style.display = past.length > 0 ? '' : 'none';
    if (pastCount)   pastCount.textContent = '(' + past.length + ')';
    if (pastList) {
      pastList.innerHTML = '';
      past.forEach(function (a) { pastList.appendChild(buildApptCard(a, true)); });
    }

    // Well-baby schedule
    var schedList = document.getElementById('gl-schedule-list');
    if (schedList) {
      schedList.innerHTML = '';
      buildWellBabySchedule().forEach(function (v) {
        var row = document.createElement('div');
        row.className = 'gl-schedule-row' + (v.daysUntil < 0 ? ' gl-schedule-row--past' : '');
        row.innerHTML =
          '<div class="gl-schedule-row__name">' + escHtml(v.name) + '</div>' +
          '<div class="gl-schedule-row__date">' + formatDate(v.targetDate) + (v.daysUntil >= 0 ? ' · in ' + v.daysUntil + 'd' : ' · past window') + '</div>' +
          (!v.alreadyLogged && v.daysUntil >= 0 ? '<button class="gl-schedule-row__btn" data-name="' + escHtml(v.name) + '" data-date="' + v.targetDate + '">Add to calendar →</button>' : '');
        schedList.appendChild(row);
      });

      schedList.addEventListener('click', function (e) {
        var btn = e.target.closest('.gl-schedule-row__btn');
        if (!btn) return;
        openApptOverlay(btn.dataset.name, btn.dataset.date);
      });
    }
  }

  function buildApptCard(a, isPast) {
    var card = document.createElement('div');
    card.className = 'gl-appt-card' + (isPast ? ' gl-appt-card--past' : '');
    var daysUntil = Math.round((new Date(a.scheduledAt) - new Date()) / 86400000);
    card.innerHTML =
      '<div class="gl-appt-card__left">' +
        '<div class="gl-appt-card__type">' + escHtml(APPT_LABELS[a.type] || a.type) + '</div>' +
        '<div class="gl-appt-card__date">' + formatDate(a.scheduledAt) + (daysUntil > 0 ? ' · in ' + daysUntil + 'd' : '') + '</div>' +
        (a.provider ? '<div class="gl-appt-card__provider">' + escHtml(a.provider) + '</div>' : '') +
      '</div>' +
      '<div class="gl-appt-card__right">' +
        (a.preVisitQuestions ? '<span class="gl-appt-card__badge">Questions ready</span>' : '') +
        (a.postVisitNotes    ? '<span class="gl-appt-card__badge gl-appt-card__badge--done">Notes added</span>' : '') +
      '</div>';
    card.addEventListener('click', function () { openApptDetail(a); });
    return card;
  }

  // ── Tab switching ─────────────────────────────────────────────────────────
  function switchTab(tab) {
    document.querySelectorAll('.gl-tab').forEach(function (b) { b.classList.toggle('gl-tab--active', b.dataset.tab === tab); });
    document.querySelectorAll('.gl-screen').forEach(function (s) { s.classList.toggle('gl-screen--active', s.id === 'gl-screen-' + tab); });
    if (tab === 'home')   renderHome();
    if (tab === 'growth') { renderChart(currentChart); renderMeasurementList(); }
    if (tab === 'appts')  renderAppointments();
  }

  // ── Add measurement overlay / inline panel ───────────────────────────────
  function openMeasurementOverlay() {
    var isDesktop = window.innerWidth >= 900;
    if (isDesktop && document.getElementById('gl-meas-panel')) {
      openMeasurementPanel();
    } else {
      openMeasurementModal();
    }
  }

  function openMeasurementModal() {
    var overlay  = document.getElementById('gl-overlay-measurement');
    var dateEl   = document.getElementById('gl-meas-date');
    var headRow  = document.getElementById('gl-meas-head-row');
    var wUnit    = document.getElementById('gl-meas-weight-unit');
    var lUnit    = document.getElementById('gl-meas-length-unit');
    var wLabel   = document.getElementById('gl-meas-weight-label');
    var lLabel   = document.getElementById('gl-meas-length-label');
    if (!overlay) return;
    if (dateEl) dateEl.value = todayIso();
    if (headRow) headRow.style.display = getAgeMonths() < 18 ? '' : 'none';
    if (wUnit)   wUnit.textContent  = prefs.unitWeight === 'lbs' ? 'lb' : 'kg';
    if (lUnit)   lUnit.textContent  = prefs.unitLength === 'in'  ? 'in' : 'cm';
    if (wLabel)  wLabel.textContent = 'Weight (' + (prefs.unitWeight === 'lbs' ? 'lb' : 'kg') + ')';
    if (lLabel)  lLabel.textContent = 'Length (' + (prefs.unitLength === 'in' ? 'in' : 'cm') + ')';
    measureBy = 'clinic';
    document.querySelectorAll('.gl-by-pill:not([data-source="panel"])').forEach(function (b) { b.classList.toggle('gl-by-pill--active', b.dataset.by === measureBy); });
    overlay.style.display = 'flex';
  }

  function openMeasurementPanel() {
    // Switch to growth tab first
    if (!document.getElementById('gl-screen-growth').classList.contains('gl-screen--active')) {
      switchTab('growth');
    }
    var panel   = document.getElementById('gl-meas-panel');
    var dateEl  = document.getElementById('gl-meas-date2');
    var headRow = document.getElementById('gl-meas-head-row2');
    var wUnit   = document.getElementById('gl-meas-weight-unit2');
    var lUnit   = document.getElementById('gl-meas-length-unit2');
    var wLabel  = document.getElementById('gl-meas-weight-label2');
    var lLabel  = document.getElementById('gl-meas-length-label2');
    if (!panel) return;
    if (dateEl)  dateEl.value = todayIso();
    if (headRow) headRow.style.display = getAgeMonths() < 18 ? '' : 'none';
    if (wUnit)   wUnit.textContent  = prefs.unitWeight === 'lbs' ? 'lb' : 'kg';
    if (lUnit)   lUnit.textContent  = prefs.unitLength === 'in'  ? 'in' : 'cm';
    if (wLabel)  wLabel.textContent = 'Weight (' + (prefs.unitWeight === 'lbs' ? 'lb' : 'kg') + ')';
    if (lLabel)  lLabel.textContent = 'Length (' + (prefs.unitLength === 'in' ? 'in' : 'cm') + ')';
    measureBy = 'clinic';
    document.querySelectorAll('.gl-by-pill[data-source="panel"]').forEach(function (b) { b.classList.toggle('gl-by-pill--active', b.dataset.by === measureBy); });
    panel.style.display = '';
    panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function saveMeasurementFromPanel() {
    var dateEl   = document.getElementById('gl-meas-date2');
    var weightEl = document.getElementById('gl-meas-weight2');
    var lengthEl = document.getElementById('gl-meas-length2');
    var headEl   = document.getElementById('gl-meas-head2');
    var notesEl  = document.getElementById('gl-meas-notes2');
    var date     = dateEl ? dateEl.value : todayIso();
    var weightKg = inputWeightToKg(weightEl && weightEl.value);
    var lengthCm = inputLengthToCm(lengthEl && lengthEl.value);
    var headCm   = headEl && headEl.value ? parseFloat(headEl.value) : null;
    if (!weightKg && !lengthCm && !headCm) { showToast('Enter at least one measurement'); return; }
    var m = {
      id: Date.now().toString(36) + Math.random().toString(36).slice(2, 5),
      measuredAt: new Date(date).toISOString(),
      weightKg: weightKg, lengthCm: lengthCm, headCircCm: headCm,
      measuredBy: measureBy, notes: notesEl ? notesEl.value.trim() : '',
    };
    measurements.unshift(m);
    saveData();
    var panel = document.getElementById('gl-meas-panel');
    if (panel) panel.style.display = 'none';
    if (weightEl) weightEl.value = '';
    if (lengthEl) lengthEl.value = '';
    if (headEl)   headEl.value   = '';
    renderHome();
    renderChart(currentChart);
    renderMeasurementList();
    showToast('Measurement saved');
  }

  function saveMeasurement() {
    var dateEl  = document.getElementById('gl-meas-date');
    var weightEl = document.getElementById('gl-meas-weight');
    var lengthEl = document.getElementById('gl-meas-length');
    var headEl   = document.getElementById('gl-meas-head');
    var notesEl  = document.getElementById('gl-meas-notes');
    var date     = dateEl ? dateEl.value : todayIso();
    var weightKg = inputWeightToKg(weightEl && weightEl.value);
    var lengthCm = inputLengthToCm(lengthEl && lengthEl.value);
    var headCm   = headEl && headEl.value ? parseFloat(headEl.value) : null;
    if (!weightKg && !lengthCm && !headCm) { showToast('Enter at least one measurement'); return; }
    var m = {
      id: Date.now().toString(36) + Math.random().toString(36).slice(2, 5),
      measuredAt: new Date(date).toISOString(),
      weightKg: weightKg, lengthCm: lengthCm, headCircCm: headCm,
      measuredBy: measureBy, notes: notesEl ? notesEl.value.trim() : '',
    };
    measurements.unshift(m);
    saveData();
    closeOverlay('gl-overlay-measurement');
    if (weightEl) weightEl.value = '';
    if (lengthEl) lengthEl.value = '';
    if (headEl)   headEl.value   = '';
    renderHome();
    renderChart(currentChart);
    renderMeasurementList();
    showToast('Measurement saved');
  }

  // ── Add appointment overlay ───────────────────────────────────────────────
  function openApptOverlay(nameOverride, dateOverride) {
    var overlay  = document.getElementById('gl-overlay-appointment');
    var dateEl   = document.getElementById('gl-appt-date');
    var typeEl   = document.getElementById('gl-appt-type');
    if (!overlay) return;
    if (dateEl) dateEl.value = dateOverride || todayIso();
    if (typeEl && nameOverride) {
      typeEl.value = 'well_baby';
      var notesEl = document.getElementById('gl-appt-notes');
      if (notesEl) notesEl.value = nameOverride;
    }
    overlay.style.display = 'flex';
  }

  function saveAppointment() {
    var typeEl    = document.getElementById('gl-appt-type');
    var dateEl    = document.getElementById('gl-appt-date');
    var timeEl    = document.getElementById('gl-appt-time');
    var provEl    = document.getElementById('gl-appt-provider');
    var locEl     = document.getElementById('gl-appt-location');
    var notesEl   = document.getElementById('gl-appt-notes');
    var date      = dateEl ? dateEl.value : todayIso();
    var time      = timeEl ? timeEl.value : '09:00';
    if (!date) { showToast('Please select a date'); return; }
    var scheduledAt = new Date(date + 'T' + time).toISOString();
    var appt = {
      id: Date.now().toString(36) + Math.random().toString(36).slice(2, 5),
      type: typeEl ? typeEl.value : 'well_baby',
      scheduledAt: scheduledAt, status: 'upcoming',
      provider: provEl ? provEl.value.trim() : '',
      location: locEl  ? locEl.value.trim()  : '',
      preVisitNotes: notesEl ? notesEl.value.trim() : '',
    };
    appointments.push(appt);
    saveData();
    closeOverlay('gl-overlay-appointment');
    renderAppointments();
    renderHome();
    showToast('Appointment saved');
  }

  // ── Appointment detail overlay ────────────────────────────────────────────
  function openApptDetail(a) {
    currentApptId = a.id;
    var overlay    = document.getElementById('gl-overlay-appt-detail');
    var titleEl    = document.getElementById('gl-appt-detail-title');
    var metaEl     = document.getElementById('gl-appt-detail-meta');
    var preSec     = document.getElementById('gl-appt-detail-pre-sec');
    var preEl      = document.getElementById('gl-appt-detail-pre');
    var qSec       = document.getElementById('gl-appt-detail-questions-sec');
    var qEl        = document.getElementById('gl-appt-detail-questions');
    var postSec    = document.getElementById('gl-appt-detail-post-sec');
    var postEl     = document.getElementById('gl-appt-detail-post');
    if (!overlay) return;
    if (titleEl) titleEl.textContent = APPT_LABELS[a.type] || a.type;
    if (metaEl)  metaEl.textContent  = formatDate(a.scheduledAt) + (a.provider ? ' · ' + a.provider : '') + (a.location ? ' · ' + a.location : '');
    if (preSec && preEl) {
      preSec.style.display = a.preVisitNotes ? '' : 'none';
      preEl.textContent    = a.preVisitNotes || '';
    }
    if (qSec && qEl) {
      var questions = a.preVisitQuestions ? JSON.parse(a.preVisitQuestions) : null;
      qSec.style.display = (questions && questions.length) ? '' : 'none';
      if (questions) {
        qEl.innerHTML = questions.map(function (q, i) { return '<div class="gl-prep-q-row"><span class="gl-prep-q-num">' + (i+1) + '</span><span>' + escHtml(q) + '</span></div>'; }).join('');
      }
    }
    if (postSec && postEl) {
      postSec.style.display = a.postVisitNotes ? '' : 'none';
      postEl.textContent    = a.postVisitNotes || '';
    }
    overlay.style.display = 'flex';
  }

  // ── Pre-appointment prep ──────────────────────────────────────────────────
  function openPrepOverlay(apptId) {
    var appt    = appointments.find(function (a) { return a.id === apptId; });
    if (!appt) return;
    currentApptId = apptId;
    var overlay   = document.getElementById('gl-overlay-prep');
    var titleEl   = document.getElementById('gl-prep-title');
    var introEl   = document.getElementById('gl-prep-intro');
    var loading   = document.getElementById('gl-prep-loading');
    var qWrap     = document.getElementById('gl-prep-questions');
    if (!overlay) return;

    closeOverlay('gl-overlay-appt-detail');
    if (titleEl) titleEl.textContent = 'Prepare for ' + (APPT_LABELS[appt.type] || 'visit');
    if (introEl) introEl.textContent = 'Based on the last 30 days of tracking:';
    if (loading) loading.style.display = '';
    if (qWrap)   qWrap.style.display = 'none';

    overlay.style.display = 'flex';

    if (appt.preVisitQuestions) {
      var existing = JSON.parse(appt.preVisitQuestions);
      if (loading) loading.style.display = 'none';
      if (qWrap) { renderPrepQuestions(existing, qWrap); qWrap.style.display = ''; }
      return;
    }

    fetchPrepQuestions(appt).then(function (questions) {
      if (!questions) questions = ['Ask about growth and development', 'Confirm vaccinations due today', 'Any concerns since the last visit?'];
      var a = appointments.find(function (x) { return x.id === apptId; });
      if (a) { a.preVisitQuestions = JSON.stringify(questions); saveData(); }
      if (loading) loading.style.display = 'none';
      if (qWrap) { renderPrepQuestions(questions, qWrap); qWrap.style.display = ''; }
    });
  }

  function renderPrepQuestions(questions, container) {
    container.innerHTML = '';
    questions.forEach(function (q, i) {
      var row = document.createElement('div');
      row.className = 'gl-prep-q-row';
      row.innerHTML = '<span class="gl-prep-q-num">' + (i+1) + '</span><span class="gl-prep-q-text">' + escHtml(q) + '</span>';
      container.appendChild(row);
    });
  }

  // ── Post-appointment notes ────────────────────────────────────────────────
  function openPostOverlay(apptId) {
    var appt    = appointments.find(function (a) { return a.id === apptId; });
    if (!appt) return;
    currentApptId = apptId;
    var overlay = document.getElementById('gl-overlay-post');
    var notesEl = document.getElementById('gl-post-notes');
    var nextEl  = document.getElementById('gl-post-nextsteps');
    var qaSec   = document.getElementById('gl-post-qa-section');
    var qaList  = document.getElementById('gl-post-qa-list');
    if (!overlay) return;
    if (notesEl) notesEl.value = appt.postVisitNotes || '';
    if (nextEl)  nextEl.value  = appt.postVisitNextSteps || '';
    if (qaSec && qaList && appt.preVisitQuestions) {
      var qs = JSON.parse(appt.preVisitQuestions);
      qaSec.style.display = '';
      qaList.innerHTML = qs.map(function (q, i) { return '<div class="gl-post-q-row"><div class="gl-post-q-text">' + (i+1) + '. ' + escHtml(q) + '</div></div>'; }).join('');
    } else if (qaSec) {
      qaSec.style.display = 'none';
    }
    closeOverlay('gl-overlay-appt-detail');
    overlay.style.display = 'flex';
  }

  function savePostNotes() {
    var appt    = appointments.find(function (a) { return a.id === currentApptId; });
    if (!appt) return;
    var notesEl = document.getElementById('gl-post-notes');
    var nextEl  = document.getElementById('gl-post-nextsteps');
    var fuEl    = document.getElementById('gl-post-followup');
    appt.postVisitNotes      = notesEl ? notesEl.value.trim() : '';
    appt.postVisitNextSteps  = nextEl  ? nextEl.value.trim()  : '';
    appt.status = 'completed';
    if (fuEl && fuEl.value) {
      var fuAppt = {
        id: Date.now().toString(36) + Math.random().toString(36).slice(2,5),
        type: appt.type, scheduledAt: new Date(fuEl.value).toISOString(),
        status: 'upcoming', vaccinesDue: [],
      };
      appointments.push(fuAppt);
    }
    saveData();
    closeOverlay('gl-overlay-post');
    renderAppointments();
    renderHome();
    showToast('Visit notes saved');
  }

  // ── Onboarding ────────────────────────────────────────────────────────────
  var obSex = 'unspecified';
  function openOnboarding() {
    var overlay = document.getElementById('gl-overlay-onboarding');
    if (!overlay) return;
    var countryEl = document.getElementById('gl-ob-country');
    var gestEl    = document.getElementById('gl-ob-gestational');
    if (countryEl) countryEl.value = prefs.country || 'US';
    if (gestEl)    gestEl.value    = prefs.gestationalAge || 40;
    obSex = prefs.sex || 'unspecified';
    document.querySelectorAll('#gl-ob-sex-pills .gl-sex-pill').forEach(function (b) { b.classList.toggle('gl-sex-pill--active', b.dataset.sex === obSex); });
    overlay.style.display = 'flex';
  }

  function saveOnboarding() {
    var gestEl = document.getElementById('gl-ob-gestational');
    var bwEl   = document.getElementById('gl-ob-birth-weight');
    var blEl   = document.getElementById('gl-ob-birth-length');
    var bhEl   = document.getElementById('gl-ob-birth-head');
    prefs.sex            = obSex;
    prefs.gestationalAge = gestEl && gestEl.value ? parseInt(gestEl.value) : 40;
    prefs.birthWeight    = bwEl  && bwEl.value  ? parseFloat(bwEl.value)  : null;
    prefs.birthLength    = blEl  && blEl.value  ? parseFloat(blEl.value)  : null;
    prefs.birthHeadCirc  = bhEl  && bhEl.value  ? parseFloat(bhEl.value)  : null;
    prefs.onboardingDone = true;
    saveData();
    closeOverlay('gl-overlay-onboarding');
    renderTopbar();
    renderHome();
    renderChart(currentChart);
  }

  // ── Settings overlay ──────────────────────────────────────────────────────
  function openSettings() {
    var overlay = document.getElementById('gl-overlay-settings');
    if (!overlay) return;
    var gestEl    = document.getElementById('gl-settings-gestational');
    var bwEl      = document.getElementById('gl-settings-birth-weight');
    var blEl      = document.getElementById('gl-settings-birth-length');
    var bhEl      = document.getElementById('gl-settings-birth-head');
    if (gestEl)    gestEl.value    = prefs.gestationalAge || 40;
    if (bwEl)      bwEl.value      = prefs.birthWeight  || '';
    if (blEl)      blEl.value      = prefs.birthLength  || '';
    if (bhEl)      bhEl.value      = prefs.birthHeadCirc || '';
    document.querySelectorAll('.gl-sex-pill:not(#gl-ob-sex-pills .gl-sex-pill)').forEach(function (b) { b.classList.toggle('gl-sex-pill--active', b.dataset.sex === (prefs.sex || 'unspecified')); });
    document.querySelectorAll('.gl-unit-pill[data-unit-type="weight"]').forEach(function (b) { b.classList.toggle('gl-unit-pill--active', b.dataset.unit === (prefs.unitWeight || 'kg')); });
    document.querySelectorAll('.gl-unit-pill[data-unit-type="length"]').forEach(function (b) { b.classList.toggle('gl-unit-pill--active', b.dataset.unit === (prefs.unitLength || 'cm')); });
    overlay.style.display = 'flex';
  }

  function saveSettings() {
    var gestEl = document.getElementById('gl-settings-gestational');
    var bwEl   = document.getElementById('gl-settings-birth-weight');
    var blEl   = document.getElementById('gl-settings-birth-length');
    var bhEl   = document.getElementById('gl-settings-birth-head');
    if (gestEl && gestEl.value) prefs.gestationalAge = parseInt(gestEl.value);
    if (bwEl  && bwEl.value)  prefs.birthWeight   = parseFloat(bwEl.value);
    if (blEl  && blEl.value)  prefs.birthLength   = parseFloat(blEl.value);
    if (bhEl  && bhEl.value)  prefs.birthHeadCirc = parseFloat(bhEl.value);
    saveData();
    closeOverlay('gl-overlay-settings');
    renderHome();
    renderChart(currentChart);
    showToast('Settings saved');
  }

  // ── Helpers ───────────────────────────────────────────────────────────────
  function closeOverlay(id) {
    var el = document.getElementById(id);
    if (el) el.style.display = 'none';
  }

  function showToast(msg) {
    var t = document.getElementById('gl-toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('gl-toast--visible');
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove('gl-toast--visible'); }, 2800);
  }

  // ── Hydrate from shared child profile ────────────────────────────────────
  function hydrateFromSharedProfile(callback) {
    var BC  = window.BirchChildren;
    var BTC = window.BirchCaregivers;
    if (!BC) { callback(); return; }

    var ownPromise = BC.load ? BC.load() : Promise.resolve([]);
    ownPromise.then(function (ownChildren) {
      var ctxPromise = BTC && BTC.getAllContexts
        ? BTC.getAllContexts('growth')
        : Promise.resolve((ownChildren || []).map(function (c) {
            return { type: 'own', childId: c.id, childName: c.name, dob: c.dob, ownerId: null, ownerName: null, label: c.name };
          }));

      ctxPromise.then(function (allCtxs) {
        _allContexts = allCtxs || [];
        if (_allContexts.length === 0) { callback(); return; }

        var ctx;
        if (_allContexts.length === 1) {
          ctx = _allContexts[0];
          applyContext(ctx);
          callback();
        } else if (prefs.onboardingDone && _trackerContext.childId) {
          ctx = _allContexts.find(function (c) { return c.childId === _trackerContext.childId; }) || _allContexts[0];
          applyContext(ctx);
          callback();
        } else {
          var picker = BC.pickContext
            ? BC.pickContext(_allContexts, { title: 'Whose growth are you tracking?' })
            : Promise.resolve(_allContexts[0]);
          picker.then(function (picked) {
            if (picked) applyContext(picked);
            callback();
          }).catch(function () { callback(); });
        }
      }).catch(function () { callback(); });
    }).catch(function () { callback(); });
  }

  function applyContext(ctx) {
    _trackerContext  = ctx;
    _activeChildId   = ctx.childId || null;
    if (ctx.childName) babyName      = ctx.childName;
    if (ctx.dob)       babyBirthdate = new Date(ctx.dob);
    prefs.babyName       = babyName;
    prefs.babyBirthdate  = ctx.dob || prefs.babyBirthdate || null;
    prefs.onboardingDone = true;
  }

  function applyChildToPrefs(name, dob, gestAge) {
    if (name) babyName = name;
    if (dob) babyBirthdate = new Date(dob);
    if (gestAge) prefs.gestationalAge = gestAge;
    prefs.babyName      = babyName;
    prefs.babyBirthdate = dob || null;
    prefs.onboardingDone = true;
    saveData();
  }

  // ── Init ──────────────────────────────────────────────────────────────────
  function init() {
    loadData();
    renderTopbar();

    // Check shared child profile before showing the growth tracker's own onboarding
    hydrateFromSharedProfile(function () {
      if (!prefs.onboardingDone) {
        openOnboarding();
        return;
      }
      // Load from cloud — cloud wins over stale localStorage
      loadFromCloud(function () {
        renderTopbar();
        renderHome();
        renderChart(currentChart);
      });
    });

    // Tabs
    document.querySelectorAll('.gl-tab').forEach(function (btn) {
      btn.addEventListener('click', function () { switchTab(btn.dataset.tab); });
    });

    // Chart tabs
    document.querySelectorAll('.gl-chart-tab').forEach(function (btn) {
      btn.addEventListener('click', function () {
        currentChart = btn.dataset.chart;
        document.querySelectorAll('.gl-chart-tab').forEach(function (b) { b.classList.toggle('gl-chart-tab--active', b.dataset.chart === currentChart); });
        renderChart(currentChart);
      });
    });

    // Home actions
    var statsAdd = document.getElementById('gl-stats-add-btn');
    if (statsAdd) statsAdd.addEventListener('click', openMeasurementOverlay);
    var chartsBtn = document.getElementById('gl-stats-charts-btn');
    if (chartsBtn) chartsBtn.addEventListener('click', function () { switchTab('growth'); });
    var quickMeasure = document.getElementById('gl-quick-measure');
    if (quickMeasure) quickMeasure.addEventListener('click', openMeasurementOverlay);
    var quickAppt = document.getElementById('gl-quick-appt');
    if (quickAppt) quickAppt.addEventListener('click', function () { openApptOverlay(); });
    var nextPrepBtn = document.getElementById('gl-next-appt-prep-btn');
    if (nextPrepBtn) nextPrepBtn.addEventListener('click', function () {
      var next = appointments.filter(function (a) { return a.status === 'upcoming' && new Date(a.scheduledAt) > new Date(); })
        .sort(function (a, b) { return new Date(a.scheduledAt) - new Date(b.scheduledAt); })[0];
      if (next) openPrepOverlay(next.id);
    });
    var nextCalBtn = document.getElementById('gl-next-appt-cal-btn');
    if (nextCalBtn) nextCalBtn.addEventListener('click', function () {
      var next = appointments.filter(function (a) { return a.status === 'upcoming' && new Date(a.scheduledAt) > new Date(); })
        .sort(function (a, b) { return new Date(a.scheduledAt) - new Date(b.scheduledAt); })[0];
      if (next) downloadIcs(next);
    });
    var apptBannerPrep = document.getElementById('gl-appt-banner-prep');
    if (apptBannerPrep) apptBannerPrep.addEventListener('click', function () {
      var next = appointments.filter(function (a) { return a.status === 'upcoming' && new Date(a.scheduledAt) > new Date(); })
        .sort(function (a, b) { return new Date(a.scheduledAt) - new Date(b.scheduledAt); })[0];
      if (next) openPrepOverlay(next.id);
    });
    var velDismiss = document.getElementById('gl-velocity-dismiss');
    if (velDismiss) velDismiss.addEventListener('click', function () {
      velocityDismissed = true;
      renderHome();
    });
    var schedViewBtn = document.getElementById('gl-schedule-view-btn');
    if (schedViewBtn) schedViewBtn.addEventListener('click', function () { switchTab('appts'); });

    // Measurement overlay / panel
    var measAdd = document.getElementById('gl-meas-add-btn');
    if (measAdd) measAdd.addEventListener('click', openMeasurementOverlay);
    var measClose = document.getElementById('gl-meas-close');
    if (measClose) measClose.addEventListener('click', function () { closeOverlay('gl-overlay-measurement'); });
    var measSave = document.getElementById('gl-meas-save');
    if (measSave) measSave.addEventListener('click', saveMeasurement);
    // Inline panel wiring
    var panelClose = document.getElementById('gl-meas-panel-close');
    if (panelClose) panelClose.addEventListener('click', function () {
      var panel = document.getElementById('gl-meas-panel');
      if (panel) panel.style.display = 'none';
    });
    var panelSave = document.getElementById('gl-meas-panel-save');
    if (panelSave) panelSave.addEventListener('click', saveMeasurementFromPanel);
    document.querySelectorAll('.gl-by-pill').forEach(function (btn) {
      btn.addEventListener('click', function () {
        measureBy = btn.dataset.by;
        var isPanel = btn.dataset.source === 'panel';
        document.querySelectorAll('.gl-by-pill').forEach(function (b) {
          if ((b.dataset.source === 'panel') !== isPanel) return;
          b.classList.toggle('gl-by-pill--active', b.dataset.by === measureBy);
        });
      });
    });

    // Appointment overlay
    var apptsAdd = document.getElementById('gl-appts-add-btn');
    if (apptsAdd) apptsAdd.addEventListener('click', function () { openApptOverlay(); });
    var apptClose = document.getElementById('gl-appt-close');
    if (apptClose) apptClose.addEventListener('click', function () { closeOverlay('gl-overlay-appointment'); });
    var apptSave = document.getElementById('gl-appt-save');
    if (apptSave) apptSave.addEventListener('click', saveAppointment);
    var apptIcs = document.getElementById('gl-appt-ics-btn');
    if (apptIcs) apptIcs.addEventListener('click', function () {
      var dateEl = document.getElementById('gl-appt-date');
      var timeEl = document.getElementById('gl-appt-time');
      var typeEl = document.getElementById('gl-appt-type');
      if (!dateEl || !dateEl.value) { showToast('Set a date first'); return; }
      var tmpAppt = { id: 'tmp', type: typeEl ? typeEl.value : 'well_baby', scheduledAt: new Date(dateEl.value + 'T' + (timeEl ? timeEl.value : '09:00')).toISOString(), vaccinesDue: [] };
      downloadIcs(tmpAppt);
    });

    // Appointment detail overlay
    var apptDetailClose = document.getElementById('gl-appt-detail-close');
    if (apptDetailClose) apptDetailClose.addEventListener('click', function () { closeOverlay('gl-overlay-appt-detail'); });
    var apptDetailPrep = document.getElementById('gl-appt-detail-prep-btn');
    if (apptDetailPrep) apptDetailPrep.addEventListener('click', function () { if (currentApptId) openPrepOverlay(currentApptId); });
    var apptDetailPost = document.getElementById('gl-appt-detail-post-btn');
    if (apptDetailPost) apptDetailPost.addEventListener('click', function () { if (currentApptId) openPostOverlay(currentApptId); });
    var apptDetailIcs = document.getElementById('gl-appt-detail-ics-btn');
    if (apptDetailIcs) apptDetailIcs.addEventListener('click', function () {
      var appt = appointments.find(function (a) { return a.id === currentApptId; });
      if (appt) downloadIcs(appt);
    });

    // Prep overlay
    var prepClose = document.getElementById('gl-prep-close');
    if (prepClose) prepClose.addEventListener('click', function () { closeOverlay('gl-overlay-prep'); });
    var prepShare = document.getElementById('gl-prep-share');
    if (prepShare) prepShare.addEventListener('click', function () {
      var appt = appointments.find(function (a) { return a.id === currentApptId; });
      if (!appt || !appt.preVisitQuestions) return;
      var qs = JSON.parse(appt.preVisitQuestions);
      var text = 'Questions for ' + babyName + "'s " + (APPT_LABELS[appt.type] || 'visit') + ' (' + formatDate(appt.scheduledAt) + '):\n\n' + qs.map(function (q, i) { return (i+1) + '. ' + q; }).join('\n');
      if (navigator.share) navigator.share({ text: text }).catch(function () {});
      else if (navigator.clipboard) navigator.clipboard.writeText(text).then(function () { showToast('Copied to clipboard'); });
    });

    // Post overlay
    var postClose = document.getElementById('gl-post-close');
    if (postClose) postClose.addEventListener('click', function () { closeOverlay('gl-overlay-post'); });
    var postSave = document.getElementById('gl-post-save');
    if (postSave) postSave.addEventListener('click', savePostNotes);

    // Child switcher (shown when multiple children are available)
    var switchBtn = document.getElementById('gl-topbar-switch-child');
    if (switchBtn) {
      switchBtn.style.display = _allContexts.length > 1 ? '' : 'none';
      switchBtn.addEventListener('click', switchActiveChild);
    }

    // Settings
    var settingsBtn = document.getElementById('gl-topbar-settings');
    if (settingsBtn) settingsBtn.addEventListener('click', openSettings);
    var settingsClose = document.getElementById('gl-settings-close');
    if (settingsClose) settingsClose.addEventListener('click', function () { closeOverlay('gl-overlay-settings'); });
    var settingsSave = document.getElementById('gl-settings-save');
    if (settingsSave) settingsSave.addEventListener('click', saveSettings);
    document.querySelectorAll('.gl-sex-pill').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var inOb = btn.closest('#gl-ob-sex-pills');
        if (inOb) { obSex = btn.dataset.sex; }
        else      { prefs.sex = btn.dataset.sex; }
        btn.closest('.gl-sex-pills').querySelectorAll('.gl-sex-pill').forEach(function (b) { b.classList.toggle('gl-sex-pill--active', b.dataset.sex === btn.dataset.sex); });
      });
    });
    document.querySelectorAll('.gl-unit-pill').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.dataset.unitType === 'weight') prefs.unitWeight = btn.dataset.unit;
        if (btn.dataset.unitType === 'length') prefs.unitLength = btn.dataset.unit;
        document.querySelectorAll('.gl-unit-pill[data-unit-type="' + btn.dataset.unitType + '"]').forEach(function (b) { b.classList.toggle('gl-unit-pill--active', b.dataset.unit === btn.dataset.unit); });
      });
    });

    // Onboarding
    var obSave = document.getElementById('gl-ob-save');
    if (obSave) obSave.addEventListener('click', saveOnboarding);

    // Head chart tab: hide at 18+ months
    var headTab = document.getElementById('gl-chart-tab-head');
    if (headTab && getAgeMonths() >= 18) headTab.style.display = 'none';

    // Past appointments toggle
    var pastToggle = document.getElementById('gl-appt-past-toggle');
    if (pastToggle) pastToggle.addEventListener('click', function () {
      var pastList = document.getElementById('gl-appt-past-list');
      if (pastList) pastList.style.display = pastList.style.display === 'none' ? '' : 'none';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
